<template>
  <v-row no-gutters>
    <v-col cols="12" md="4" offset-md="4" class="pa-4">
      <v-card outlined>
        <span class="primary--text"><center><h2 class="mt-3">Chan Nyein Dental Clinic</h2></center></span>
        <v-alert v-model="showError" dense type="error" class="mb-4 ml-2 mr-2">
                <div>{{ errorMessage }}</div>
              </v-alert>
        <v-form>
        <v-row no-gutters class="pa-2">
          <v-col cols="12" md="12">
          </v-col>
          <v-col cols="12" md="12">
            <v-text-field v-model="userAccount.userName" label="User Name" filled outlined/>
          </v-col>
          <v-col cols="12" md="12">
            <v-text-field @keyup.enter="accountLogin" v-model="userAccount.password" label="Password" filled outlined/>
          </v-col>
          <v-col cols="12" md="12" class="text-right">
            <v-btn color="primary" @click="accountLogin">Login</v-btn>
          </v-col>
        </v-row>
      </v-form>
      </v-card>
    </v-col>
  </v-row>
  </template>
  <script>
  import loginService from "../service/LoginService";
  export default {
    mounted: function() {
      let loginUser = this.$store.state.userAccount;
    if(loginUser.password!=""){
        if(loginUser.role!="PATIENT"){
              this.$router.push("/of/home").catch(() => {});
            }else{
              this.$router.push("/p/patient").catch(() => {});
              location.reload();
            }
    }
    },
    data() {
      return {
        userAccount: {
          userName: "",
          password: ""
        },
        nameRules: [v => !!v || "Name is required"],
        passwordRules: [v => !!v || "Password is required"],
        showError: false,
        errorMessage: "",
      user:{userAccountId:0},
      };
    },
     props: {
      hideToolbar: Function
    },
    methods: {
      userList:function(){
        this.hideToolbar(false);
      },
      accountLogin: function() {
        if (
          this.userAccount.userName.length != 0 &&
          this.userAccount.password.length != 0
        ) {
          loginService
            .loginAccount(this.userAccount)
            .then(data => {
              this.$store.commit("updateUserAccount", data);
              this.hideToolbar(false);
              this.$router.push("/home").catch(() => {});
            })
            .catch(e => {
              if (e != undefined) {
                this.showError = true;
                if (e.response == undefined) {
                  this.errorMessage = "Server Error";
                } else {
                  if (e.response.data == undefined) {
                    this.errorMessage = "No Internet Connection.";
                  } else {
                    this.errorMessage = e.response.data.message;
                  }
                }
              }
            });
        } else {
          this.showError = true;
          this.errorMessage = "Fill,User Name and Password.";
        }
      },
    },
    components: {}
    
  };
  </script>
  
  <style>
  .login-full {
    height: 90vh;
  }
  .card-title {
    margin-bottom: 10px;
  }
  .title-main {
    font-size: 1.6rem;
    font-weight: 800;
    color: red;
    letter-spacing: 0.08rem;
  }
  .title-sub {
    text-align: left;
    color: #348df3;
  }
  .information-window-v-sheet {
    height: 100vh !important;
    overflow-x: scroll;
  }
  </style>